import { api } from "./client";
// import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createWarehouse = async (warehouseData) => {
  try {
    const response = await api.post(
      `${API_BASE_URL}api/warehouse/warehouses`,
      warehouseData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": localStorage.getItem("lang") || "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Create Warehouse Error:", error);
    throw error;
  }
};

export const fetchWarehouses = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/warehouse/list`, {
      headers: {
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch Warehouses Error:", error);
    throw error;
  }
};

// Update api
export const updateWarehouse = async (id, payload) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/warehouse/warehouses/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": localStorage.getItem("lang") || "en",
          "Content-Type": "application/json",
        },
      }
    );
    
    return response.data;
  } catch (error) {
    console.error("Update Store Error:", error);
    // toast.error(
    //   error?.response?.data?.error || "❌ Failed to update store"
    // );
    throw error;
  }
};

//delete api
export const deleteWarehouse = async (id) => {
  const res = await api.delete(`${API_BASE_URL}api/warehouse/warehouses/${id}`);
  return res.data;
};

// Get All Warehouse 
export const getAllWarehouses = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/warehouse/list`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": localStorage.getItem("lang") || "en",
      },
    });

    // Only return active warehouses
    return response.data.filter((w) => w.status === "Active");
  } catch (error) {
    console.error("❌ Error fetching warehouses:", error);
    throw error;
  }
};

// Get Warehouse by ID
export const getWarehouseById = async (id) => {
  try {
    const res = await api.get(`${process.env.REACT_APP_API_BASE_URL}api/warehouse/warehouses/${id}`);
    return res.data;
  } catch (err) {
    console.error("Error fetching warehouse:", err);
    throw err;
  }
};